// extracted by mini-css-extract-plugin
module.exports = {"normalImage":"_3crG8","normalImageWrapper":"_14Esu"};